import { render, staticRenderFns } from "./ServiceNavbar.vue?vue&type=template&id=67ad51ef&scoped=true&"
import script from "./ServiceNavbar.vue?vue&type=script&lang=ts&"
export * from "./ServiceNavbar.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceNavbar.vue?vue&type=style&index=0&id=67ad51ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ad51ef",
  null
  
)

export default component.exports